// src/stone/icons/PaymentLink.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var PaymentLink = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M12.082 2C6.532 2 2 6.51 2 12H0C0 5.39 5.442 0 12.082 0c4.487 0 8.425 2.448 10.512 6.05l-.106.75-1.378.705A10.15 10.15 0 0 0 12.082 2M11.918 22C17.468 22 22 17.49 22 12h2c0 6.61-5.442 12-12.082 12a12.16 12.16 0 0 1-10.251-5.621L2 16.95l.89-.455A10.15 10.15 0 0 0 11.918 22" }),
      /* @__PURE__ */ jsx("path", { d: "m23.11 2.125-.713 6.02-5.536-.845.301-1.977 3.492.532.47-3.966zM1.603 15.856l5.536.844-.301 1.977-3.493-.533-.47 3.967-1.986-.236zM13.048 4.5V19h-2V4.5z" }),
      /* @__PURE__ */ jsx("path", { d: "M11.43 6.303c1.468-.1 3.15.254 4.059.73l.885.465-.93 1.771-.885-.465c-.531-.279-1.834-.585-2.993-.506-.572.04-.984.166-1.225.328-.184.124-.29.273-.29.576 0 .392.147.625.474.854.394.275.963.476 1.708.713l.16.051c.643.203 1.423.45 2.04.83.734.452 1.375 1.18 1.375 2.317 0 .94-.332 1.723-.955 2.286-.592.534-1.356.789-2.098.895-1.474.211-3.226-.11-4.605-.586l-.945-.327.652-1.89.945.326c1.212.418 2.625.647 3.67.497.517-.074.85-.227 1.04-.4.16-.144.296-.365.296-.8 0-.237-.08-.403-.424-.615-.398-.245-.952-.421-1.686-.655l-.072-.023c-.693-.22-1.563-.501-2.249-.981-.752-.528-1.325-1.326-1.325-2.492 0-1 .462-1.756 1.172-2.235.654-.44 1.465-.614 2.206-.664" })
    ]
  }
);
var PaymentLink_default = PaymentLink;

export {
  PaymentLink_default
};
